import { footer } from "./Footer";
import { firstForm } from "./FirstForm";
import { secondForm } from "./SecondForm";
import { devWarning } from "./DevWarning";

export const translations = {
  pt: {
    footer: footer.pt,
    firstForm: firstForm.pt,
    secondForm: secondForm.pt,
    devWarning: devWarning.pt,
  },
  en: {
    footer: footer.en,
    firstForm: firstForm.en,
    secondForm: secondForm.en,
    devWarning: devWarning.en,
  },
};
